import { useEffect, useState } from 'react';
import SiteImage from './SiteImage';
import SafeIcon from '../common/SafeIcon';
import { useSiteContent } from '../context/SiteContent';

export default function GalleryGrid({ compact = false }) {
  const { site } = useSiteContent();
  const [active, setActive] = useState(-1);
  const close = () => setActive(-1);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowRight') setActive((index) => Math.min(index + 1, site.images.gallery.length - 1));
      if (event.key === 'ArrowLeft') setActive((index) => Math.max(index - 1, 0));
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [site.images.gallery.length]);

  return (
    <>
      <div className={`gallery-grid${compact ? ' gallery-compact' : ''}`}>
        {site.images.gallery.map((src, index) => (
          <button className={`gallery-tile gallery-tile-${index + 1}`} type="button" key={src} onClick={() => setActive(index)} aria-label={`Open image: ${site.galleryAlts[index]}`}>
            <SiteImage src={src} alt={site.galleryAlts[index]} />
            <span className="gallery-zoom"><SafeIcon name="Maximize2" /></span>
          </button>
        ))}
      </div>
      {active >= 0 && (
        <div className="lightbox" role="dialog" aria-modal="true" aria-label="Gallery image" onClick={close}>
          <button className="lightbox-close" type="button" onClick={close} aria-label="Close image"><SafeIcon name="X" /></button>
          <SiteImage src={site.images.gallery[active]} alt={site.galleryAlts[active]} className="lightbox-image" />
          <p>{site.galleryAlts[active]}</p>
        </div>
      )}
    </>
  );
}